import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class ParkCityLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Park City, UT" />
        <LocationMicroNav />

        <LocationContent 
          category="Bike Biz" 
          title="Getting to Know You"
          story="We went to Salt Lake City to check out one of the most popular locations in our growing DRAFT meetup series. DRAFT is a nationwide program that taps into people who love bikes, biz and beer. Our events bring communities together to celebrate the latest bike industry innovations. Speeches, announcements and conversations help business leaders, product developers, tech innovators, advocates, artists and more to share big ideas—all while enjoying delicious craft beer. In 2017, we hosted 30 meetups in 18 cities, including Boulder, Cedar Rapids, Des Moines, Denver, Detroit, Duluth, Frisco (CO), Indianapolis, Iowa City, Los Angeles, Milwaukee, New York, Park City, Salt Lake, San Francisco, Raleigh, the Twin Cities and Washington, D.C. In 2018 at least 10 more cities will join the DRAFT family including Austin, Bentonville, Chicago, Kent (WA), Madison, Philadelphia, Phoenix, Portland, St. Augustine and Vail."
        />  
        <Img
          title="ParkCityUT"
          alt="DRAFT meetup in Park City, UT"
          sizes= { this.props.data.parkCityImage.sizes }
        />   

        <LocationRelated 
          prevLocationName="Albany, NY"
          prevLocationPath="albany"
          prevLocationImgPath= { this.props.data.parkCityPrevImage }
          nextLocationName="Huntsville, AL"
          nextLocationPath="huntsville"
          nextLocationImgPath= { this.props.data.parkCityNextImage }
        /> 
      </div>
    )
  }
}

export default ParkCityLocation

// GraphQL query
export const ParkCityImageQuery = graphql`
  query ParkCityImageQuery {
    parkCityImage: imageSharp(id: { regex: "/PFB_ParkCityUT/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    parkCityPrevImage: imageSharp(id: { regex: "/PFB_ALBANY/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    parkCityNextImage: imageSharp(id: { regex: "/PFB_HUNTSVILLE/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/park-city.js